var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1837_1032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3242 12.4002C16.3242 14.5502 14.5742 16.3002 12.4242 16.3002H4.59922C2.44922 16.3002 0.699219 14.5502 0.699219 12.4002V4.6002C0.699219 2.4502 2.44922 0.700195 4.59922 0.700195H12.4242C14.5742 0.700195 16.3242 2.4502 16.3242 4.6002V12.4002Z",
    fill: "url(#paint0_linear_1837_1032)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 7.16895V10.7689C13 11.5977 12.3287 12.2689 11.5 12.2689H5.5C4.675 12.2689 4 11.5977 4 10.7689V7.16895L7.58125 9.56895C8.12087 9.98895 8.87875 9.98895 9.41838 9.56895L13 7.16895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 7.16895L9.41875 9.94432C8.878 10.3636 8.12162 10.3636 7.58087 9.94432L4 7.16895C4 6.3402 4.675 5.66895 5.5 5.66895H11.5C12.3287 5.66895 13 6.3402 13 7.16895Z",
    fill: "#B5D1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0046 5.66868C12.0046 6.1483 11.6157 6.5368 11.1365 6.5368C10.6565 6.5368 10.2676 6.1483 10.2676 5.66868C10.2676 5.18905 10.6565 4.7998 11.1365 4.7998C11.6157 4.7998 12.0046 5.18905 12.0046 5.66868Z",
    fill: "#2979FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1837_1032",
    x1: 8.65397,
    y1: -5.2343,
    x2: 8.41797,
    y2: 15.7184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5301FE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1837_1032"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera1);
export default __webpack_public_path__ + "static/media/camera1.ba1268b6fb2ced1fb91900985c93fea6.svg";
export { ForwardRef as ReactComponent };